import { Box } from '@mui/material';
import React from 'react';
import AuthLeftCard from '../../../shared/components/AuthLeftCard';
import LoginForm from './components/LoginForm';

const Login = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        width: '100vw',
      }}
    >
      {/* Left side */}
      <AuthLeftCard />
      {/* Right side */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <LoginForm />
      </Box>
    </Box>
  );
};

export default Login;
